interface ICustomIconProps {
  iconName: string
  className?: string,
  color?: string,
  fill?: string,
  stroke?: string
}


const CustomIcon: React.FC<ICustomIconProps> = ({ iconName, className, fill, stroke, color = 'black' }: ICustomIconProps) => {
  const pickIcon = () => {
    switch (iconName.toLowerCase()) {
      case 'show-password': return <ShowPassword className={className as string} color={color as string} />
      case 'accordion-divider': return <AccordionDivider className={className as string} />
      case 'airplane-takeoff': return <AirplaneTakeoff className={className as string} />
      case 'airplane-landing': return <AirplaneLanding className={className as string} />
      case 'airplane-outline': return <AirplaneOutline className={className as string} color={color} />
      case 'airplane-solid': return <AirplaneSolid className={className as string} color={color} />
      case 'arrow': return <ArrowIcon className={className as string} color={color as string} />
      case 'arrow_alert': return <ArrowAlertIcon className={className as string} color={color as string} />
      case 'arrow-profile': return <ArrowIconProfile className={className as string} stroke={stroke as string} fill={fill as string} />
      case 'arrow-back': return <ArrowIconBack className={className as string} stroke={stroke as string} fill={fill as string} />
      case 'burger': return <BurgerIcon className={className as string} />
      case 'close': return <CloseIcon className={className as string} color={color as string} />
      case 'info': return <InfoIcon className={className as string} />
      case 'phone': return <PhoneIcon className={className as string} />
      case 'user': return <UserIcon className={className as string} color={color} />
      case 'user-solid': return <UserIconSolid className={className as string} color={color} />
      case 'search': return <SearchIcon className={className as string} color={color} />
      case 'prm': return <PRMIcon className={className as string} color={color} />
      case 'divider': return <DividerIcon className={className as string} />
      case 'marker': return <Marker className={className as string} />
      case 'location': return <LocationIcon className={className as string} />
      case 'location-destination': return <LocationIconDestination className={className as string} />
      case 'location-reward': return <LocationIconReward className={className as string} stroke={stroke as string} fill={fill as string} color={color}/>
      case 'cup-bg-blue': return <CupBackgroundBlue className={className as string} stroke={stroke as string} fill={fill as string} color={color}/>
      case 'cup-blue': return <CupBlue className={className as string} stroke={stroke as string} fill={fill as string} color={color}/>
      case 'check': return <CheckIcon className={className as string} />
      case 'airplane': return <AirplaneIcon className={className as string} />
      case 'refresh': return <RefreshIcon className={className as string} />
      case 'active-square': return <ActiveSquare className={className as string} />
      case 'black-square': return <BlackSquare className={className as string} />
      case 'black-circle': return <BlackCircle className={className as string} />
      case 'not-active-square': return <NotActiveSquare className={className as string} />
      case 'mail': return <Mail className={className as string} />
      case 'departureplane': return <DeparturePlane className={className as string} />
      case 'longarrow': return <LongArrow className={className as string} />
      case 'longarrow-mobile': return <LongArrowMobile className={className as string} />
      case 'chevron-r': return <ChevronRight color={color} className={className as string} />
      case 'chevron-r-search': return <ChevronRightSearch color={color} className={className as string} />
      case 'chevron-r-airlines': return <ChevronRightAirlines color={color} className={className as string} />
      case 'bar-points-full': return <BarPointsFull className={className as string} />
      case 'bar-points-progress': return <BarPointsProgress className={className as string} />
      case 'fidelity-card-outline': return <FidelityCardOutline className={className as string} color={color} />
      case 'fidelity-card-solid': return <FidelityCardSolid className={className as string} color={color} />
      case 'bag-outline': return <BagOutline className={className as string} color={color} />
      case 'bag-solid': return <BagSolid className={className as string} color={color} />
      case 'logout': return <LogoutIcon className={className as string} color={color} />
      case 'qrcode-account': return <QrCodeAccount className={className as string} color={color} />
      case 'noflights': return <NoFlights className={className as string} />
      case 'nopurchases': return <NoPurchases className={className as string} />
      case 'download': return <DownloadIcon color={color} className={className as string} />
      case 'dots': return <Dots className={className as string} />
      case 'no-result': return <NoResult className={className as string} />
      case 'walking': return <Walking className={className as string} />
      case 'calendar': return <Calendar className={className as string} />
      case 'clock': return <Clock className={className as string} />
      case 'lock': return <LockIcon className={className as string} />
    }
  }

  return (
    <>
      {pickIcon()}
    </>
  )
}

const ShowPassword = ({ className, color = "" }: { className: string, color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256"
      height="256"
      viewBox="0 0 256 256"
      className={className}
    >
      <g
        fill="#000"
        strokeMiterlimit="10"
        strokeWidth="1"
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      >
        <path d="M45 66.739c-11.987 0-21.74-9.752-21.74-21.739S33.013 23.26 45 23.26 66.739 33.013 66.739 45 56.987 66.739 45 66.739zm0-37.479c-8.679 0-15.74 7.061-15.74 15.74S36.321 60.739 45 60.739 60.739 53.679 60.739 45 53.679 29.26 45 29.26z"></path>
        <path d="M45 66.763c-14.477 0-28.953-6.054-43.328-18.16C.609 47.708 0 46.395 0 45s.609-2.708 1.672-3.603c28.751-24.214 57.906-24.214 86.656 0C89.391 42.293 90 43.605 90 45s-.609 2.707-1.672 3.602C73.953 60.709 59.477 66.763 45 66.763zM6.726 45c25.74 21.046 50.809 21.048 76.547 0-25.737-21.046-50.806-21.048-76.547 0zm77.733.984l.004.003-.004-.003z"></path>
        <circle cx="45" cy="45" r="7"></circle>
      </g>
    </svg>
  )
}

const LongArrowMobile = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="63"
      height="15"
      fill="none"
      viewBox="0 0 63 15"
    >
      <path
        fill="#000"
        d="M1.2 6.497a1 1 0 000 2v-2zm60.707 1.707a1 1 0 000-1.414L55.543.426A1 1 0 1054.13 1.84l5.657 5.657-5.657 5.657a1 1 0 001.414 1.414l6.364-6.364zM1.2 8.497h60v-2h-60v2z"
      ></path>
    </svg>
  )
}

const InfoIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className={className}>
      <g clipPath="url(#clip0_3216_360)">
        <path d="M10.5 0A10.502 10.502 0 0121 10.5 10.5 10.5 0 1110.5 0zm0 18.9a8.398 8.398 0 008.4-8.4A8.399 8.399 0 004.56 4.56 8.399 8.399 0 0010.5 18.9z"></path>
        <path d="M10.5 8.744c.278 0 .545.107.742.298.198.19.308.448.308.717v6.088c0 .363-.2.697-.525.879a1.082 1.082 0 01-1.05 0 1.009 1.009 0 01-.525-.879V9.759c0-.27.11-.527.307-.718.197-.19.464-.297.743-.297zM9.465 4.559a1.456 1.456 0 011.588-.306c.366.132.655.42.787.787.083.173.123.363.117.554A1.46 1.46 0 0110.5 7.052a1.458 1.458 0 01-.554-.117 1.697 1.697 0 01-.481-.306 1.456 1.456 0 01-.306-1.589c.07-.178.173-.342.306-.48v-.001z"></path>
      </g>
      <defs>
        <clipPath id="clip0_3216_360">
          <path d="M0 0H21V21H0z" transform="matrix(-1 0 0 1 21 0)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

const LockIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      fill="none"
      viewBox="0 0 13 16"
    >
      <path
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9.727 8.32h1.18a.506.506 0 01.507.506v5.738a.506.506 0 01-.506.506H1.795a.506.506 0 01-.506-.506V8.826a.506.506 0 01.506-.506h1.182m6.75 0V4.945c0-1.125-.675-3.375-3.375-3.375S2.977 3.82 2.977 4.945V8.32m6.75 0h-6.75"
      ></path>
    </svg>
  )
}

const Walking = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      /* width="15"
      height="27" */
      viewBox="0 0 15 27"
      className={className}
    >
      <g fill="#fff" clipPath="url(#clip0_6279_39880)">
        <path d="M9.568 2.464c0 1.265-.951 2.29-2.124 2.29S5.32 3.73 5.32 2.464c0-1.265.951-2.29 2.124-2.29S9.568 1.2 9.568 2.464M13.321 10.836a.83.83 0 00.78-.375.982.982 0 00.09-.916.862.862 0 00-.691-.541c-1.876-.099-3.638-.995-4.902-2.492a1.318 1.318 0 00-1.13-.54.798.798 0 00-.33.092h-.086C3.732 7.575.895 13.208.776 13.446a.98.98 0 00-.067.697.904.904 0 00.41.544.795.795 0 00.648.072.867.867 0 00.504-.443A20.692 20.692 0 016.62 8.418c-.085 3.178-.722 10.707-4.74 16.185a.981.981 0 00.128 1.31.82.82 0 001.214-.138c2.079-2.968 3.529-6.392 4.248-10.03 1.13 1.09 3.236 3.774 4.374 9.279.043.206.151.39.306.521.155.13.347.199.543.194h.187a.855.855 0 00.532-.402.974.974 0 00.114-.688c-1.512-7.328-4.638-10.149-5.657-10.9.256-1.657.406-3.331.45-5.01 1.445 1.205 3.182 1.934 5.003 2.097z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6279_39880">
          <path
            fill="#fff"
            d="M0 0H13.591V25.946H0z"
            transform="translate(.674 .174)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  )
}

const DownloadIcon = ({ className, color = 'white' }: { className: string, color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      viewBox="0 0 14 19"
      className={className}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 17.32h12m-6-16v12m0 0l3.5-3.5M7 13.32l-3.5-3.5"
      ></path>
    </svg>
  )
}

const ArrowIcon = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" className={className}>
      <path
        fill={color}
        // stroke={color}
        d="M2.1 15.3c-.3 0-.6-.1-.9-.4-.5-.5-.5-1.3 0-1.8L6.3 8 1.2 3c-.5-.5-.5-1.3 0-1.8S2.5.7 3 1.2l6 6c.2.2.4.6.4.9s-.2.6-.4.9l-6 6c-.2.2-.6.3-.9.3z" />
    </svg>
  )
}

const ArrowAlertIcon = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" className={className}>
      <path
        fill={color}
        // stroke={color}
        d="M2.1 15.3c-.3 0-.6-.1-.9-.4-.5-.5-.5-1.3 0-1.8L6.3 8 1.2 3c-.5-.5-.5-1.3 0-1.8S2.5.7 3 1.2l6 6c.2.2.4.6.4.9s-.2.6-.4.9l-6 6c-.2.2-.6.3-.9.3z" />
    </svg>
  )
}

const ArrowIconProfile = ({ className, fill = 'black', stroke = 'black' }: Pick<ICustomIconProps, "className" | "fill" | "stroke">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" className={className}>
      <path
        fill={fill}
        stroke={stroke}
        d="M2.1 15.3c-.3 0-.6-.1-.9-.4-.5-.5-.5-1.3 0-1.8L6.3 8 1.2 3c-.5-.5-.5-1.3 0-1.8S2.5.7 3 1.2l6 6c.2.2.4.6.4.9s-.2.6-.4.9l-6 6c-.2.2-.6.3-.9.3z" />
    </svg>
  )
}

const ArrowIconBack = ({ className, fill = 'black', stroke = 'black' }: Pick<ICustomIconProps, "className" | "fill" | "stroke">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="38" viewBox="0 0 30 38" fill="none">
      <path d="M1.29289 18.4614C0.902369 18.8519 0.902369 19.485 1.29289 19.8756L7.65685 26.2395C8.04738 26.63 8.68054 26.63 9.07107 26.2395C9.46159 25.849 9.46159 25.2158 9.07107 24.8253L3.41421 19.1685L9.07107 13.5116C9.46159 13.1211 9.46159 12.4879 9.07107 12.0974C8.68054 11.7069 8.04738 11.7069 7.65685 12.0974L1.29289 18.4614ZM2 20.1685H22V18.1685H2V20.1685Z" fill="black" />
    </svg>
  )
}

const PhoneIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" className={className}>
      <path d="M14.022 15.064C12.3832 15.064 10.7309 14.6399 9.0652 13.7916C7.39952 12.9434 5.89461 11.8497 4.55493 10.5104C3.21524 9.17111 2.12117 7.66664 1.2727 6.00147C0.424233 4.33629 0 2.6845 0 1.04611C0 0.764858 0.0937779 0.528251 0.276868 0.345215C0.464424 0.157715 0.69217 0.0639648 0.960107 0.0639648H3.48318C3.70646 0.0639648 3.89848 0.135393 4.06371 0.273786C4.22894 0.416643 4.34058 0.613072 4.39863 0.863072L4.9345 3.22914C4.96576 3.43897 4.95237 3.63539 4.89878 3.81843C4.84519 4.00593 4.76035 4.14879 4.63977 4.25147L2.56326 6.30504C3.42513 7.73361 4.3763 8.95682 5.41233 9.97914C6.44835 10.997 7.64067 11.8854 8.99375 12.6443L11.0256 10.5461C11.173 10.3988 11.3337 10.2872 11.5079 10.2202C11.6776 10.1533 11.8607 10.1443 12.0527 10.1845L14.1962 10.6533C14.4329 10.7113 14.6294 10.8318 14.7767 11.0104C14.9241 11.189 15 11.4033 15 11.6577V14.0684C15 14.3497 14.9062 14.5863 14.7231 14.7738C14.5356 14.9613 14.3034 15.0506 14.0176 15.0506L14.022 15.064ZM2.07651 5.42111L3.90741 3.63539C3.90741 3.63539 3.93867 3.59075 3.95207 3.54611C3.96547 3.50147 3.96547 3.46575 3.95207 3.4345L3.46085 1.18004C3.46085 1.13539 3.44299 1.09968 3.40726 1.07736C3.37154 1.05504 3.32688 1.04611 3.28669 1.04611H1.09408C1.06282 1.04611 1.03602 1.05504 1.01369 1.07736C0.991367 1.09968 0.982435 1.12646 0.982435 1.15771C0.969038 1.73807 1.05389 2.38093 1.23698 3.08629C1.42453 3.79164 1.7014 4.56843 2.07205 5.41664L2.07651 5.42111ZM13.9104 14.0818C13.955 14.0818 13.9863 14.0684 14.0086 14.0461C14.031 14.0238 14.0444 13.997 14.0444 13.9702V11.7827C14.0444 11.7381 14.031 11.6979 14.0086 11.6577C13.9863 11.622 13.9461 11.6041 13.8881 11.6041L11.8785 11.18C11.8473 11.18 11.8249 11.18 11.8026 11.1934C11.7803 11.2024 11.7535 11.2113 11.7267 11.2291L9.94046 13.1041C10.5344 13.4033 11.1998 13.6354 11.9277 13.8095C12.6556 13.9836 13.3209 14.0729 13.9149 14.0863L13.9104 14.0818Z" />
    </svg>
  )
}



const UserIcon = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="25"
      fill="none"
      viewBox="0 0 23 25"
      className={className}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22 24v-3c0-1.591-.553-3.117-1.538-4.243C19.478 15.632 18.142 15 16.75 15H6.25c-1.392 0-2.728.632-3.712 1.757C1.553 17.883 1 19.41 1 21v3M11.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
      ></path>
    </svg>
  );
}
const UserIconSolid = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.0197 19.9441V17.4658C18.0197 16.1512 17.5628 14.8905 16.7494 13.961C15.9361 13.0315 14.833 12.5093 13.6827 12.5093H5.00883C3.8586 12.5093 2.75548 13.0315 1.94214 13.961C1.1288 14.8905 0.671875 16.1512 0.671875 17.4658V19.9441" fill={color} />
      <path d="M9.34426 10.0308C11.8536 10.0308 13.8877 7.99662 13.8877 5.48733C13.8877 2.97803 11.8536 0.943848 9.34426 0.943848C6.83497 0.943848 4.80078 2.97803 4.80078 5.48733C4.80078 7.99662 6.83497 10.0308 9.34426 10.0308Z" fill={color} />
    </svg>
  );
}

const SearchIcon = ({ className, color ="black" }: Pick<ICustomIconProps, "className" | "color">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
      className={className}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.222 21.445c5.646 0 10.223-4.577 10.223-10.223C21.445 5.577 16.867 1 11.222 1 5.577 1 1 5.577 1 11.222c0 5.646 4.577 10.223 10.222 10.223zM24 24l-5.559-5.558"
      ></path>
    </svg>
  );
}

const PRMIcon = ({ className, color ="black" }: Pick<ICustomIconProps, "className" | "color">) => {
  return (
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6_4)">
        <path d="M13.7118 10.27H11.3875L10.8547 8.4765C10.449 7.11146 10.1362 6.9086 8.71237 6.9086C7.18239 6.9086 5.14432 7.64799 5.58037 9.11351L6.8582 13.4058C7.23927 14.6874 8.41851 15.5671 9.757 15.5671H14.8038L16.8836 20.631C17.1453 21.2699 17.8903 21.5581 18.5141 21.2642C19.062 21.0064 19.3331 20.3845 19.1511 19.8082L17.5093 14.6192C17.187 13.5992 16.2409 12.9072 15.1698 12.9072H10.7542C10.1021 12.9072 9.5276 12.4787 9.3437 11.855L8.73323 9.8093" stroke="#2B2B2B" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.62193 11.1952C2.13366 12.4635 1.19141 14.3499 1.19141 16.4582C1.19141 20.2746 4.28739 23.3687 8.1038 23.3687C10.6424 23.3687 12.8587 22.0036 14.0607 19.9674" stroke="#2B2B2B" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.5216 4.95773C8.71631 4.95773 9.68481 3.98923 9.68481 2.79452C9.68481 1.59982 8.71631 0.631317 7.5216 0.631317C6.3269 0.631317 5.3584 1.59982 5.3584 2.79452C5.3584 3.98923 6.3269 4.95773 7.5216 4.95773Z" stroke="#2B2B2B" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_6_4">
          <rect width="19.2774" height="24" fill="white" transform="translate(0.560059)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

const DividerIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1"
      height="28"
      fill="none"
      viewBox="0 0 1 28"
      className={className}
    >
      <path stroke="#333" strokeLinecap="round" d="M.5.5v27"></path>
    </svg>
  );
}

const BurgerIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg className={className} width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="11.5615" y1="12" x2="30.4384" y2="12" stroke="#333333" strokeWidth="2" />
      <line x1="11.5615" y1="20" x2="30.4384" y2="20" stroke="#333333" strokeWidth="2" />
      <line x1="11.5615" y1="28" x2="30.4384" y2="28" stroke="#333333" strokeWidth="2" />
    </svg>
  )
}

const CloseIcon = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" color={color}>
      <path
        stroke={color}
        strokeWidth="2"
        d="M12.265 28.321L28.321 12.265"
      ></path>
      <path
        stroke={color}
        strokeWidth="2"
        d="M12.269 12.265L28.325 28.321"
      ></path>
    </svg>
  )
}

const Marker = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" className={className}>
      <path d="M15.5,37.1c-0.1,0-0.3,0-0.4,0c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.2-0.5-0.4-0.7-0.7L3.3,22c0,0,0,0,0,0l0,0l0,0
     C1.8,19.6,1,17,1,14.3s0.8-5.4,2.3-7.7c2.1-3.2,5.4-5.3,9.1-6.1c3.8-0.8,7.7-0.1,10.9,1.9c1.6,1,3,2.3,4.1,3.8
     c1.1,1.5,1.8,3.2,2.3,5.1c0.4,1.8,0.4,3.7,0.1,5.5c-0.3,1.8-1.1,3.6-2.1,5.1L27.6,22c-0.1,0.1-0.2,0.2-0.2,0.3l-9.8,13.7
     c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.2-0.6,0.3-0.9,0.4C15.9,37.1,15.7,37.1,15.5,37.1z M5,20.8l0.3,0.5l9.8,13.6
     c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1l9.8-13.6
     c0.1-0.2,0.2-0.3,0.3-0.4l0,0c0.9-1.3,1.5-2.8,1.8-4.4c0.3-1.6,0.3-3.2-0.1-4.7c-0.3-1.6-1-3-1.9-4.3c-0.9-1.3-2.1-2.4-3.5-3.3
     c-2.8-1.7-6.2-2.4-9.4-1.7C9.6,3.1,6.8,5,5,7.7c-1.3,2-2,4.2-2,6.6C3,16.6,3.7,18.8,5,20.8z M15.5,20.7c-1.8,0-3.4-0.7-4.7-1.9
     c-1.2-1.2-2-2.9-2-4.6s0.7-3.4,2-4.6c1.3-1.2,2.9-1.9,4.7-1.9c1.8,0,3.4,0.7,4.7,1.9c1.2,1.2,2,2.9,2,4.6s-0.7,3.4-2,4.6
     C18.9,20.1,17.3,20.7,15.5,20.7z M15.5,9.8c-1.2,0-2.4,0.5-3.3,1.3c-0.9,0.8-1.3,2-1.3,3.2s0.5,2.3,1.3,3.2c0.9,0.8,2.1,1.3,3.3,1.3
     c1.2,0,2.4-0.5,3.3-1.3c0.9-0.8,1.3-2,1.3-3.2s-0.5-2.3-1.3-3.2C17.9,10.3,16.7,9.8,15.5,9.8z"/>
    </svg>
  )
}

const AccordionDivider = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="30"
      fill="none"
      viewBox="0 0 5 30"
      className={className}
    >
      <path
        stroke="#666666"
        strokeDasharray="1 8"
        strokeLinecap="round"
        strokeWidth="4"
        d="M2.5 2.219L2.5 27.22"
      ></path>
    </svg>
  )
}

const LocationIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="34"
      viewBox="0 0 13 15"
      className={className}
    >
      <path
        d="M6.56 7.237c.342 0 .631-.12.875-.36.24-.241.36-.535.36-.877 0-.343-.12-.633-.36-.877-.24-.24-.533-.36-.876-.36-.342 0-.632.12-.875.36-.24.24-.36.534-.36.877 0 .342.12.632.36.876.24.24.533.36.875.36zm0 5.849c1.563-1.425 2.721-2.718 3.47-3.88.748-1.16 1.12-2.181 1.12-3.065 0-1.389-.446-2.527-1.335-3.41-.89-.884-1.974-1.326-3.256-1.326-1.282 0-2.369.442-3.259 1.325-.89.884-1.33 2.022-1.33 3.411 0 .884.38 1.905 1.147 3.068.766 1.159 1.913 2.453 3.442 3.877zm0 1.396c-1.897-1.615-3.313-3.114-4.245-4.5C1.38 8.598.91 7.319.91 6.138c0-1.763.568-3.17 1.702-4.22C3.749.867 5.066.345 6.559.345c1.494 0 2.81.523 3.944 1.572 1.137 1.05 1.705 2.457 1.705 4.224 0 1.177-.47 2.46-1.401 3.845-.936 1.386-2.352 2.884-4.248 4.5v-.004z"
      ></path>
    </svg>
  )
}

const LocationIconDestination = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="34"
      viewBox="0 0 13 15"
      className={className}
    >
      <path
        d="M6.56 7.237c.342 0 .631-.12.875-.36.24-.241.36-.535.36-.877 0-.343-.12-.633-.36-.877-.24-.24-.533-.36-.876-.36-.342 0-.632.12-.875.36-.24.24-.36.534-.36.877 0 .342.12.632.36.876.24.24.533.36.875.36zm0 5.849c1.563-1.425 2.721-2.718 3.47-3.88.748-1.16 1.12-2.181 1.12-3.065 0-1.389-.446-2.527-1.335-3.41-.89-.884-1.974-1.326-3.256-1.326-1.282 0-2.369.442-3.259 1.325-.89.884-1.33 2.022-1.33 3.411 0 .884.38 1.905 1.147 3.068.766 1.159 1.913 2.453 3.442 3.877zm0 1.396c-1.897-1.615-3.313-3.114-4.245-4.5C1.38 8.598.91 7.319.91 6.138c0-1.763.568-3.17 1.702-4.22C3.749.867 5.066.345 6.559.345c1.494 0 2.81.523 3.944 1.572 1.137 1.05 1.705 2.457 1.705 4.224 0 1.177-.47 2.46-1.401 3.845-.936 1.386-2.352 2.884-4.248 4.5v-.004z"
      ></path>
    </svg>
  )
}

const LocationIconReward = ({ className, color, stroke }: Pick<ICustomIconProps, "className" | "fill" | "stroke" | "color">) => {
  return (
    <svg className={className} stroke={stroke} color={color} xmlns="http://www.w3.org/2000/svg" width="31" height="37" viewBox="0 0 31 37" fill="none">
      <path d="M3.2764 21.2227L3.34492 21.3155C3.42866 21.4332 3.51621 21.5473 3.60375 21.6722L13.5232 35.0268C13.6395 35.183 13.7876 35.3161 13.9589 35.4185C14.1302 35.521 14.3214 35.5908 14.5215 35.6239C14.7216 35.6571 14.9267 35.6529 15.1251 35.6116C15.3235 35.5704 15.5112 35.4929 15.6776 35.3835C15.8255 35.2861 15.9543 35.1654 16.0583 35.0268L25.9549 21.6829C26.05 21.558 26.1414 21.4367 26.2327 21.3262L26.2936 21.2406C27.2715 19.8244 27.9421 18.2416 28.267 16.5825C28.5919 14.9235 28.5648 13.2207 28.1873 11.5714C27.8098 9.92215 27.0892 8.35875 26.0668 6.97052C25.0444 5.58229 23.7401 4.39643 22.2284 3.48069C19.1765 1.63262 15.4663 0.996125 11.9137 1.71119C8.36103 2.42625 5.25693 4.43431 3.28402 7.29376C1.85175 9.3706 1.08984 11.7908 1.08984 14.2636C1.08984 16.7364 1.85175 19.1566 3.28402 21.2334L3.2764 21.2227ZM14.7945 8.92743C16.3088 8.92743 17.7611 9.49113 18.8318 10.4945C19.9026 11.4979 20.5041 12.8588 20.5041 14.2779C20.5041 15.6969 19.9026 17.0578 18.8318 18.0612C17.7611 19.0646 16.3088 19.6283 14.7945 19.6283C13.2803 19.6283 11.828 19.0646 10.7573 18.0612C9.68651 17.0578 9.08496 15.6969 9.08496 14.2779C9.08496 12.8588 9.68651 11.4979 10.7573 10.4945C11.828 9.49113 13.2803 8.92743 14.7945 8.92743Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const CupBackgroundBlue = ({ className, color, stroke }: Pick<ICustomIconProps, "className" | "fill" | "stroke" | "color">) => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="60px" height="60px" viewBox="0 0 60 60" enableBackground="new 0 0 60 60">  <image id="image0" width="60" height="60" x="0" y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAA
      CXBIWXMAAA7EAAAOxAGVKw4bAAATWUlEQVRo3uWbZ4xc13XHf+e+96bvzhZu3+XukhQldkkUKcsW
      rGJZtiU5si0gsuxYBtINBEiQ8iGAAUVBAH8w4g8BgthIgR0Hjg3YgZ1iuVvVRaZEkWrksi53ye19
      duq79+TDm5kddkpcOR9ygQcMZt499/zPOfe0ewf+nw15qxNin/0s+06flYrzDMb4ez/ye2lNul71
      zAaBdkVaBQREr5s7VYOIom5acROh07nxQwemZo4cKuHQUixjXz/xsvLMM+8A4Cee4LZDedr+/FF/
      07x2SmA24bEFp4MKXaDNiGRQSUd09boBS5U/hWWEBVVWjHBWYULgbFF49cjrB+bsD07oaztT5D//
      5PoB3jsy5e0/nNtg0/PDCLcaMXcAt3m+NyDGj6GKqgpoje71a7hKR0RAjALqwkpRnZtQOIyzT1nr
      Xg6W2icO704vPL+rt3JdgIf27KFvz62S/LMnY5snFwcM4aOg94vxBlHXrKppMSaQOpn1wHgZNqtL
      qHOoaojIqvG8RReGRxX9iap7Kt45duyp+YXisft+97KU/Cst07VzH7c89vsb7OTsHYo+ALxXRLZ4
      vu+rOpy1qFMUd1XhrcOIpCmCGOMb42WN72fVuW6c6wPZUpke+PrOlv6njxExdBnRXXp88gt/5zXt
      ur1XrH8vwiPimbtETFqtNbXtqQ3zRd5ZvKrauE+0vpoxiDFOrVtxzn7bKV8uleTgVz6yd/lSdLwL
      v+jbtZ9t73+Yzfc9NADBIxj5HeP7t6OawjlTX1gEARGpGvQ7DDjax1JbR6itqQoRS3Ex3iZUh43Y
      0X2PfWZahjeXzz33wysD3vaBj5p9v/WHvU70IYRPi5jdxpiEs7a6lEh1KamDfIfBngc8YkGlqu9o
      dysIYjwvBnSJ0OPEzhfj8fHCm8cqubmJywPe/tVvxltWc/cJfMr4/m3GmLirVOq2W9PqrxPkJXHL
      mtC1yo1zToznxY3x+lAXb01n5vbv2HrOX5kLR0dHATB1Ek88wd6RKW94crEf9H3imdvV2pithDUZ
      1uDWp2gt1Kr+Wp/6ulVealsMQJ1FnU0Z4z1ojPkEQ7t6tj/+hTrTdQ3v37eP27fv6pSVwuMi+mFj
      /C5UjdShCud/+L8f0rClIlVI1bxFjO/H1DlKamfIeOPx5Wx+bOSFKCzF/vKzdN/3gBeeXRg2xrtf
      xGxRZ41qNBnViyxYq9+1xQNaY16DqbwzoxbhS06ZyFeoOHeJdzTSx5oVDAEPYvRwuTU3C6gPsPPo
      tHTfGetWo7eJZwY93/dtuRyZyuUyRBECI9w/3M3e7hace+fSjtrwRVgsV/jSKyeZzpcuZikCHfnu
      MESMlxV1+5x12/q27TqS/vSncz6AnxbP8+UmVO5BtcVVpVedigCBWbPlminFjJCNB8wv53jm9AR5
      987YuwKBwO29bfS2txL3PeK+V1VITbcQuvoXKGCMiDppEZE7e2/ed2Lz3v0vRpmWGk9gqxp5F5BW
      ayNHr4pRZSATZ09PO3E/2vJJz8NUBdDfnGLk1Cg/OzWBzWTXo2a4GLAITYHHjh6PhO/xwKZuiqEF
      oBg6LIp1ytHpBUYWVwmjDahVXmKK7kS4IefkJR/g3Y9/KlVU1x+LpTbYMPScDasmomxrSfLwjQM0
      JeOEbg1MzT9mAi8yewHPmHfErEUE43mIZwjEMNicwjZkXkpk7jd3NPODkTF+Mb2MFSPqnAI+IoOK
      Djixvg+QD/1+Y6RNqVc7AGTjAfds6iURBPzHG2dYcVp30orii/DA5p63B6KmvWt836lSsUo+DPnP
      4xMslMqYhg0UE+X+4S7u3dLPWP4Uo6slRBWMMX4s1h0WS8O+8+I+gBFzgyBd6pxUzUAUaEvG6cok
      OTaf4/BcjpJza3FYlbhnKIYXe8vL5tUa7TXfCM2Bx2roKFkXva969WRGoOKUU0s5plZL58VhI9DX
      nObujZ30ZjOczpXqUvU8X0IpN7kKLSZiUHtBW1VVGkWudW1WKSJI1ZRqi5Vr7vlqqqqCBaUv4fPb
      u4fZ0ZJaSyauRc21aqWeEhBpse431qyv/rqCWiuCppxxG6vhU5JA0LiwAIurBaaWc/RkEgTSSKoR
      h5JIJkgk4lfAGs0TIGEMd/S2MZhN867eNrIxr05Tr+DwDIJvqgZ4nlKqWgR6MgmWVlc5MzOPkbVN
      U6Wb9n2NADs0qRA7z3oElioh5/JlmgOPjmqZ3xibo1CgdG9op7O9LQIlDYFf6yVs3cH0Jnxu6myl
      bJXB1ma2ZOKYmrbqPJ4/XwHPCHHfo2gttp7RrjmurC+0xzwWypbZkm0QxVohCepHGlbxAe/CIOoQ
      TiysosAdG7vxL8q2IF+xJIKARBBcygKxGoWM0Dl8Ve4c6sET4ccnz7FYqnD35j5a4j4Va7FOsQ1W
      pg2EfCMkPUPFgbvAEJxTdnW10paM8/rMIs73G6A0RBapZloiF/xSBSPAyPwy48t5bmxrYnNzkiNL
      hQZSykolJOF7pALvPLMUYEPcZ6AlQ8o3pAx0pBJs62jmxPwKPx6dIhb43Lmxk0e29nFmcYWiQj5U
      JlfynFstYev0hMAY0oHHmbkFSuXyeYC7kz43d2RZLJV56dwc9uIisA7Qr3N3gdRqEioqPDc2zSd2
      DHHfpl4Wj44zVU3rnCpzhcgbJqplhqk63HTg8ciN/Qy1NhEYQykMKVvHbL7E06OTVMTjxYl5+pqS
      9DWlGMqmSQQ+VpW5fJGvvTnG2EqxWuMrcd8Q9wwnJ6fJl8rgRxaVjfl8YHMPHekk3zlyhvxlwNbG
      FXta1ayNkYU83x85w0Pbhvno1j7+a2Scs6slnAgLhTLWKbFKCWyIehHJUJWZQonhljQVq3z79ZOM
      LKxi/YBcxaLAxGqJL786SuBCOuMej+65gY50ksWypVALd1VLy3gGEaHoxXEmqs9bYx4f3NTNLd3t
      PH9qnFdmlnBXKWMu/2tDjAuBVxaLPH3qHD3JgE/sHOKO3jaaAo+VcoV8JWSoPUtTPKjH4FLo+O7x
      c3zvzVNYG3Lbxh7SqWQdrESFO6uhRYKAfUO9pAKPn41O8O2Rs8wVynU+fCP0JiONlv0YycBnz4Zm
      Htu2kR0bmvnl6ATPT61QxDQ0YS4d06+o4agyjGx9pRzyo9EZpnN5HrxxkI/eNMDOuRWOL+ZYLFUY
      2tBK89kFcrlifV5RhRdmclgd5YHtm3hwSy/fqoOJ6CZ8wz0bO9nb08Zzx8/ww7F5crqmB1UlHvhs
      626n4pSudILdHc3s6MiCwo+Oj/PCuTmK1HzIlRuKVwS8JqkoD6+I4ZX5PDOHT3LnQCdb25rY3JbB
      E8E6R9Yo56qr1txCBcMrSyX2FSpsSAQkPVNnDCDmefQ0pShUHC/NF+tgG1PPjBHaEzGa4wH3DXVS
      sY4T8zmeH5vm5NIq5dq+lav3J64KuEZJqkmHRTiTL/PNo+MMZpPsbG9mczZNX0sTe/o6OZY7S9iY
      /YiA8Yj7hjNTM8wsLdPV3ExvOsZcocLUapGp5RyDzUnEmDUhV+cbhP5UQMIT5vMFjs4tM7KY5+jc
      MkUVdK1he03NmGsETK2NUk0KoAIcWypwbD5Hb8Ln47s2sTGTIFBLqA1dVCDteyQ8j1giwbsHOrm1
      r5O+piSz+RIvT85hRPBF8MMS6hyYNZP2Dezo7SBfKvONV45xvBDijF8r9q89D6+Ot96ZaQjaAojn
      ca7kGJlbpiURY3dXK0ZqWoqS2SZx+KJs72rng1sHCARemV6kEIbcM9jNbX0dGIGUC6n30Krr9Dcl
      GWhKMlMMGS0pavy6IC/k6VrGtWv4PPpV0NW9KkY4ODHHrd2t7GjLcHByngqmvqdaU3F8Y1gqFDk8
      s8zPx2dZDB0pA7f1tHFzR5b+bIbBrg6Ojs1RqW0J59jclKA5HvCTUxOExoDTqzqmdQd8IXCAeSuc
      WS2zpTXDDdkUry0VMVWhHJ1d5luvn2aqFDKeK0YZFELFKj85M8NrM4sMN6c4tbBMZS380pmKsaez
      hZnVIm/MrmCdXrTuWx3X32ysJvrF0PKzsRmCIGBnexNxtdVTEFh0wi+mlzm9UsRqLW2tFQbCZCHk
      hYlFJku61sFA2ZZN0t2c5oXTEyxV7HWzuj6A17rBjOeKHJxYYE9fJ3s6sngNijDGXJDBSh2cVH9v
      3IvD2TT3bunn3EqBE7ly7SzrupuE69JOrkWgQmh5enSSmdU8H7phgC2tmYa6tCYfqZtk4+eaEITI
      lN+/qQdR5UcnxpmuZl3r0S9bF8DS4LkniyHfHxkjEOWhzb0MNqfOY/a8Orfx2KT6VsYT7u5tZTib
      5sDUIm8sFtbS3HU40zIA6urXFK4btADHV0OePztHRyrOx7b2sb09QyBrhyGNAGqLGqC/KcEj2zay
      v7+TV6bmeWZsFofUo8F6jGo9LA5w12sztT1aVvjp2CwOuHewi9+8aYCfj89yeGaZqXyxfvAFoOpo
      8j12d7VyR187XZkkBycXeOrkJEvlsC6Y9QLtVxnNK5SvlxgNKWHZKc+OzTG5vMrdGzu4a2MHN3e1
      MracZ7pYoWQtgRHaYgE96Tj92QyLhRLfeeM0hxbyrJTtBaSvF66qOokAKywi5BHRWs789jGvFRsl
      53htfpUzy3n2dzbz4e2b6EwnKLs1bXlGSHiGQ9NLfPf4OFP5Mpa17bF+Q8qCXYgSD6dTGFmuXylY
      jxtWNSJGWLIwUYlumrx4dpbJQpl0EFB2loQR3ruxk6PTC4yvljBizifzNmFr7dBJBIkqtLyzOu5H
      eN24wZsziDYkOtftxGr9KE+gK51ABEYWchycWa6GK6U7neCOvg20+BBU7wPVu5/rNxRY9tQ/EzXi
      E2ZMkGnnXFhvYl8UMt6WhEGVmGfY3JJhqVBiseqIlKj7mK9YpleL7O7rpD2VWJ+zqcbSVJ1WisUC
      MI1H3gBMHD64DDrlbJhT57QxxFzPqNEZbkqwsTnJ61MLnFtarZeZAiwVSxycmKUtlWBrU2KtBXc9
      Ao/WVRPd4Atx7nVRfdP3pGIAxl962arKuKLHRKQkYt7WZcn6WW2DdnszCe7f3EO5EnJwaoFy9XKC
      1h/D0YU8o4srvG9LPzs6mqPOZ52mvg1Oqvcfo3S1CPxSnR60jtAABL5aFfeaqn5PjFkwfr17q9cq
      5cb7LQCBMQw3J/nY1n4Gsxlem1vhbCEkFfikfI909ckEPrnQ8dPj4/jq+I0tfexubyLle+dxf+18
      NGZyoKoFVXe06MLTBzN55wMc78y6G+zqaEoSzzlrHlTVLkSiS2jX6Dxq/WNEaI/7vKdvA7d0t9Ke
      jGFVGWhO8fHtGy+9TSTKtIIgoCXm8+j2QV6fW+bZMzOM5QprL12D1GvO0ngezoarqvoawpHTR19a
      /tnyjHoAhRdeoLm1zQ696z1huVjuB+03ntdUX6XxdO4KjSOptmruG+ri3sEuFGW5HFIKHcnAJxsP
      aL7M0xQPqDiN2rYSVUspUQ6fm8UZv07/ipqtfhQRPM/HWXsC+HcNvGeef/nZpdznPrfWAHh5QxOm
      vWV6+0Lh38B1AR8BSag6qUVVuWq0UtKBT28myUKxzNffHCNXCd+y8xMRHtjUTRMhJr+CzcavMiMq
      sOtX0kXUWVsGDony3wc3dk1OHjgANHQ88k8+ybNPPllOvXzqyND03FM2tBu9INhnxIu5SoU66is0
      zGqtFyNQso5zuQIr1TD0VgEvFSt0UT3/vRpcrdmeRMidrqqGP1bk6we+9qWzB776j/VT+4vKw7kD
      LxTV8qxz+k0XhifVuVA8v6pZARFVVa275EuzXLv+WK95r/WpHZ1ei4taO7gTBdR4HqAFVA9Y3JdX
      kpUfHBzqKTbOuainNfP3n3cv79o3fstjf/A/qi7hrH7Si8W2qrMBRDcE6v9pUJXLaTsd89jdmaVk
      L3t1+Yoq60rF0Xzp0tAjU1JZ+xzZglJS1Vcd9osl6z1/+B/+pWS//qXzpl4E+PShQ5w+dMht+djD
      pzPxzm96npezpdLDiNxhPC8N4KzV+lFbQydciM6DC6El5Xs8tLnnbWdOvhFOrK7gvDUWGx1TvVHv
      eRjjYW1YtmH5x6ryr0Xn//QrD9w6x4MX072sP+nYvp39j/+R6b9lf6codwk8jMgtCIO+H0vUbsTX
      GKmaoRgRhrMputKJtwl1bSzkSxyZXayfSNY2SnQrPtpizoY5YAzlDXXua+VY+alf/eNXS69+44uX
      lPWVHehdd9G7e6/s+tRnMkPTy5vE4yGEB7xYcKM6l1LnAgFTPwo8r0W3PuNiigoiFpESqjln7WHg
      Kd+ZH6bGR07+7Zk38vZv/vqy9K6Jrw1/8hd86COfDNKr5V7EHxZxe1S4V5DdYqTTi8UTiAjRHzBY
      u/+zHmBrrSGDCGor5dDZcAzHi6o8g8hriBnVGTd55J/+NHzmKv9huna+nniCG4+eovOW95qBvXva
      myvmXcBNItqrRvoEMigJhYRAoOvQIKzm86FAEcgDy6CzKpwSyyFPeemXX/vnpWA17c4d/BWnTz9z
      LTTf4njiCfY+/sdy2/FTgQ1DowEJFdcXWK9X1HQi2iFIRiFArqPai7JEq05zKsyDGxd1p4zKbCXh
      l5LWs23+YvhX99zzltb4X7Wqj2Ijfq/lAAAAO3RFWHRDb21tZW50AHhyOmQ6REFGeEp2enlET0k6
      OCxqOjY4NjE2NDA2MzczMzEzNDk0MDgsdDoyMzEwMjAxNGaPBC8AAAAldEVYdGRhdGU6Y3JlYXRl
      ADIwMjMtMTAtMjBUMTc6MDE6MjUrMDI6MDAxFQxyAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEw
      LTIwVDE3OjAxOjI1KzAyOjAwQEi0zgAAAABJRU5ErkJggg==" />
    </svg>
  )
}

const CupBlue = ({ className, color, stroke }: Pick<ICustomIconProps, "className" | "fill" | "stroke" | "color">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 60 60"><image width="60" height="60" href="data:image/png;base64,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"/></svg>
  )
}

const CheckIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="15"
      fill="black"
      viewBox="0 0 20 15"
    >
      <polygon points="8.3,15.1 0.4,7.2 2.6,5.1 8.3,10.9 18.8,0.4 20.9,2.5 " />
    </svg>
  )
}

const AirplaneIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      fill="none"
      viewBox="0 0 19 20"
      className={className}
    >
      <path
        fill="#000"
        d="M3.284 16.25l.414-.717 2.53-.305 3.33-5.767L.526 7.297l.57-.988 10.342-.102 3.071-5.32c.148-.255.364-.423.65-.504.287-.085.563-.046.83.109.269.155.438.378.51.665.07.292.033.564-.112.815l-3.07 5.319 5.104 9.021-.57.987-6.413-6.754L8.12 16.29l1.01 2.379-.414.718-2.251-2.347-3.181-.79z"
      ></path>
    </svg>
  )
}

const RefreshIcon = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      fill="none"
      viewBox="0 0 19 18"
    >
      <path
        fill="#333"
        d="M9.1 18c-2.502 0-4.63-.879-6.375-2.636C.974 13.606.101 11.484.101 9c0-2.485.873-4.63 2.618-6.376C4.464.88 6.598 0 9.101 0c1.636 0 3.09.358 4.363 1.079 1.273.715 2.346 1.703 3.213 2.957v-3.4c0-.181.06-.333.181-.454A.659.659 0 0117.343 0c.2 0 .364.06.485.182a.617.617 0 01.182.454V5.88c0 .26-.079.466-.243.618a.857.857 0 01-.606.23H11.95a.626.626 0 01-.485-.2.676.676 0 01-.181-.466c0-.176.06-.34.181-.467a.626.626 0 01.485-.2h4.06a8.65 8.65 0 00-2.848-2.958c-1.17-.739-2.527-1.103-4.06-1.103-2.164 0-3.982.74-5.467 2.23C2.15 5.049 1.41 6.862 1.41 9.007c0 2.14.745 3.952 2.23 5.436 1.485 1.485 3.31 2.23 5.473 2.23a7.666 7.666 0 004.255-1.26c1.303-.836 2.266-1.976 2.897-3.406a.582.582 0 01.254-.303.74.74 0 01.376-.121c.26 0 .448.079.557.242.11.164.128.352.049.576a8.792 8.792 0 01-3.303 4.079c-1.515 1.024-3.212 1.533-5.091 1.527L9.1 18z"
      ></path>
    </svg>
  )
}

const ActiveSquare = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 81 80" fill="none">
      <rect x="0.125" width="70" height="70" rx="23" fill="#14688E" />
    </svg>
  )
}

const DeparturePlane = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      width="49"
      height="26"
      viewBox="0 0 49 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path d="M48.6159 21.3103C48.6159 21.8608 48.5111 22.406 48.3074 22.9145C48.1037 23.4231 47.8052 23.8852 47.4289 24.2743C47.0526 24.6634 46.6058 24.9719 46.1143 25.1823C45.6227 25.3926 45.0958 25.5005 44.5639 25.5H12.7379C12.5382 25.4968 12.3433 25.4357 12.1754 25.3237L3.28713 20.1337C3.05168 19.9917 2.87426 19.7658 2.78806 19.4982L0.779867 13.9843C0.591133 13.4963 0.564592 12.9571 0.704421 12.4516C0.844251 11.9462 1.14251 11.5033 1.55225 11.1926C2.01174 10.8451 2.57571 10.6782 3.14323 10.7218C3.71074 10.7653 4.24475 11.0165 4.64969 11.4303L10.1158 17.141H17.5623L12.5478 4.50208C12.2931 3.86594 12.266 3.15669 12.4711 2.50168C12.6763 1.84668 13.1004 1.28884 13.6672 0.928352C14.234 0.567862 14.9065 0.428337 15.5637 0.534833C16.221 0.64133 16.8201 0.986871 17.2533 1.5094L30.2531 17.1H44.5639C45.0974 17.1 45.6256 17.209 46.1182 17.4208C46.6109 17.6326 47.0583 17.943 47.4347 18.3342C47.8112 18.7253 48.1094 19.1896 48.3121 19.7003C48.5148 20.211 48.618 20.7581 48.6159 21.3103Z" fill="#14688E" />
    </svg>

  )
}

const LongArrow = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      width="124"
      height="24"
      viewBox="0 0 124 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path d="M1.61597 10.5C0.78754 10.5 0.115967 11.1716 0.115967 12C0.115967 12.8284 0.78754 13.5 1.61597 13.5V10.5ZM122.677 13.0607C123.262 12.4749 123.262 11.5251 122.677 10.9393L113.131 1.3934C112.545 0.807611 111.595 0.807611 111.009 1.3934C110.424 1.97919 110.424 2.92893 111.009 3.51472L119.495 12L111.009 20.4853C110.424 21.0711 110.424 22.0208 111.009 22.6066C111.595 23.1924 112.545 23.1924 113.131 22.6066L122.677 13.0607ZM1.61597 13.5H121.616V10.5H1.61597V13.5Z" fill="black" />
    </svg>
  )
}

const NotActiveSquare = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 81 80" fill="none">
      <rect width="70" height="70" rx="23" fill="#666666" />
    </svg>
  )
}

const BlackSquare = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 81 80" fill="none" className={className}>
      <rect width="70" height="70" rx="23" fill="black" />
    </svg>
  )
}

const BlackCircle = ({className}: Pick<ICustomIconProps, "className">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 512 512" className={className}>
      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/>
    </svg>
  )
}

const Mail = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="70" height="55" viewBox="0 0 78 55" fill="none">
      <path d="M37.0853 32.799L7.38234 4.37199C7.58936 4.32153 7.7991 4.29322 8.01052 4.29322H8.01219H69.9878C70.2 4.29322 70.4102 4.32154 70.6171 4.37196L40.9713 32.7993L40.9711 32.7995C40.3576 33.3884 39.6807 33.6585 39.0298 33.6585C38.3788 33.6585 37.7009 33.3883 37.0854 32.799L37.0853 32.799ZM4.75442 47.1799V8.46241L24.9927 27.8369L4.86774 48.1317C4.79401 47.8321 4.75442 47.5133 4.75442 47.1799ZM53.0652 27.8034L73.2439 8.46158V47.1748C73.2439 47.497 73.2039 47.8049 73.131 48.0967L53.0652 27.8034ZM8.01219 -0.5C3.54911 -0.5 0 3.28522 0 7.79304V47.1765C0 51.6834 3.54496 55.5 8.01219 55.5H69.9878C74.4533 55.5 78 51.6835 78 47.1765V7.79304C78 3.28345 74.4508 -0.5 69.9878 -0.5H8.01219ZM44.2458 36.2762L49.6125 31.1329L68.9663 50.7068H9.06463L28.4459 31.1627L33.8115 36.2765C33.8117 36.2767 33.8119 36.2769 33.8121 36.2771C36.7301 39.0709 41.3274 39.0747 44.2458 36.2762Z" fill="#14688E" stroke="#14688E" />
    </svg>
  )
}

const ChevronRight = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="16"
      fill="none"
      viewBox="0 0 9 16"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.203 1.553L7.65 8l-6.447 6.447"
      ></path>
    </svg>
  )
}

const ChevronRightSearch = ({ className }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="16"
      fill="none"
      viewBox="0 0 9 16"
    >
      <path
        stroke=""
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.203 1.553L7.65 8l-6.447 6.447"
      ></path>
    </svg>
  )
}

const ChevronRightAirlines = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="8.5"
      height="8.5"
      fill="none"
      viewBox="0 0 9 16"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M1.203 1.553L7.65 8l-6.447 6.447"
      ></path>
    </svg>
  )
}

const Dots = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="5"
      fill="none"
      viewBox="0 0 51 5"
    >
      <path
        stroke="#666666"
        strokeDasharray="1 8"
        strokeLinecap="round"
        strokeWidth="4"
        d="M2 2.5L49 2.5"
      ></path>
    </svg>

  )
}

const NoResult = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="68"
      fill="none"
      viewBox="0 0 68 68"
    >
      <rect
        width="67.727"
        height="67.727"
        x="0.215"
        fill="#E6E6E6"
        rx="23"
      ></rect>
      <path
        stroke="#14688E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M32.538 44.646c6.805 0 12.323-5.517 12.323-12.323S39.343 20 32.538 20c-6.806 0-12.323 5.517-12.323 12.323s5.517 12.323 12.323 12.323zM20.213 44.646L44.86 20M47.943 47.727l-6.7-6.7"
      ></path>
    </svg>

  )
}

const BarPointsFull = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg
      width='258px'
      height='8px'
      viewBox='0 0 258 8'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g fill='#666666'>
        <rect id='Rectangle' x={1} y={3} width='253.387' height={2} rx={1} />
        <circle id='Oval' cx={4} cy={4} r={4} />
        <circle id='Oval' cx='54.00002' cy={4} r={4} />
        <circle id='Oval' cx='104.00012' cy={4} r={4} />
        <circle id='Oval' cx='154.00012' cy={4} r={4} />
        <circle id='Oval' cx='204.00012' cy={4} r={4} />
        <circle id='Oval' cx='254.00012' cy={4} r={4} />
      </g>
    </svg>
  );
}

const BarPointsProgress = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg width="258px" height="8px" viewBox="0 0 258 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g>
        <rect id="Rectangle" fill="#666666" x={1} y={3} width="253.387" height={2} rx={1} />
        <circle id="Oval" fill="#E20129" cx={4} cy={4} r={4} />
        <circle id="Oval" fill="#E20129" cx="54.00002" cy={4} r={4} />
        <circle id="Oval" fill="#E20129" cx="104.00012" cy={4} r={4} />
        <circle id="Oval" fill="#E20129" cx="154.00012" cy={4} r={4} />
        <circle id="Oval" fill="#E20129" cx="204.00012" cy={4} r={4} />
        <circle id="Oval" fill="#E20129" cx="254.00012" cy={4} r={4} />
        <rect id="Rectangle" fill="#E20129" x={1} y={2} width={251} height={4} rx={2} />
      </g>
    </svg>
  )
}

const NoFlights = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.73979 25.6019C6.4621 25.8796 6.33106 26.2716 6.38594 26.6605C6.44081 27.0493 6.67524 27.3898 7.01892 27.5798L10.6792 29.6032L12.678 33.2378C12.8675 33.5823 13.208 33.8176 13.5973 33.873C13.9866 33.9284 14.3792 33.7974 14.6572 33.5194L15.4702 32.7064C15.7478 32.4288 15.8789 32.0368 15.8241 31.648L15.4109 28.7165L20.2904 23.837L25.6565 33.7142C25.8447 34.0606 26.1854 34.298 26.5757 34.3545C26.9659 34.4111 27.3599 34.2801 27.6387 34.0013L28.7566 32.8835C29.0696 32.5704 29.1937 32.1152 29.0829 31.6866L25.6628 18.4646L31.1788 12.9487C31.698 12.4294 31.9686 11.771 31.9877 11.0471L31.988 11.032C31.9988 10.2744 31.7137 9.59196 31.1778 9.05604C30.6534 8.53167 29.9773 8.22745 29.1944 8.24597C28.4624 8.25823 27.8039 8.53638 27.2852 9.05508L21.7685 14.5718L8.57106 11.1759C8.14286 11.0657 7.68832 11.1899 7.37568 11.5025L6.25783 12.6204C5.97889 12.8993 5.84799 13.2936 5.9047 13.684C5.96141 14.0744 6.19908 14.4151 6.54586 14.6031L16.3959 19.9444L11.493 24.8473L8.61363 24.4354C8.22408 24.3797 7.83103 24.5107 7.55277 24.7889L6.73979 25.6019Z" stroke="#14688E" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M36.8073 36.0665L4.1875 3.44678" stroke="#14688E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const FidelityCardOutline = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10799_269)">
        <path d="M5.66602 4.9248H6.11583" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.66602 8.19775H6.11583" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.66602 11.4702H6.11583" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.66602 14.7432H6.11583" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22.6026 7.5854C22.5464 5.19397 23.2773 1.45604 19.9037 1.30176H3.35052C-0.0230978 1.47241 0.71235 5.17994 0.651625 7.5854C2.7905 8.10903 2.7905 11.5594 0.651625 12.0831C0.707852 14.4745 -0.0230978 18.2124 3.35052 18.3667H19.9037C23.2773 18.196 22.5419 14.4885 22.6026 12.0831C20.4637 11.5594 20.4637 8.10903 22.6026 7.5854Z" stroke={color} strokeMiterlimit="10" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_10799_269">
          <rect width="22.9091" height="18" fill="white" transform="translate(0.171875 0.833984)" />
        </clipPath>
      </defs>
    </svg>

  )
}

const FidelityCardSolid = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10799_605)">
        <path d="M23.1026 6.97553C23.0464 4.5841 23.7773 0.84618 20.4037 0.691895H3.85052C0.476902 0.862544 1.21235 4.57008 1.15163 6.97553C3.2905 7.49917 3.2905 10.9496 1.15163 11.4732C1.20785 13.8646 0.476902 17.6025 3.85052 17.7568H20.4037C23.7773 17.5862 23.0419 13.8786 23.1026 11.4732C20.9637 10.9496 20.9637 7.49917 23.1026 6.97553Z" fill={color} stroke={color} strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M6.16602 4.31494H6.61583" stroke="#E6E6E6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.16602 7.58789H6.61583" stroke="#E6E6E6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.16602 10.8604H6.61583" stroke="#E6E6E6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.16602 14.1333H6.61583" stroke="#E6E6E6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10799_605">
          <rect width="22.9091" height="18" fill="white" transform="translate(0.671875 0.224121)" />
        </clipPath>
      </defs>
    </svg>

  )
}

const AirplaneOutline = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.960083 12.2387C0.849009 12.3498 0.796591 12.5066 0.818542 12.6621C0.840494 12.8176 0.934264 12.9538 1.07174 13.0298L3.52652 14.3868L4.86737 16.825C4.94316 16.9628 5.07937 17.057 5.23507 17.0791C5.39078 17.1013 5.54783 17.0489 5.65904 16.9376L6.18676 16.4099C6.29781 16.2989 6.35023 16.1421 6.32831 15.9866L6.03841 13.9299L9.61045 10.3579L13.2927 17.1356C13.368 17.2742 13.5042 17.3692 13.6603 17.3918C13.8164 17.4144 13.974 17.362 14.0856 17.2505L14.8112 16.5249C14.9364 16.3997 14.986 16.2175 14.9417 16.0461L12.6771 7.2912L16.3834 3.58486C16.662 3.30627 16.8071 2.95565 16.8174 2.5625L16.8175 2.5625L16.8176 2.55648C16.8233 2.1511 16.6728 1.7885 16.3828 1.49847C16.0974 1.21308 15.7386 1.05363 15.3218 1.06379C14.9267 1.07015 14.5761 1.21823 14.2964 1.49785L10.5898 5.20449L1.851 2.95587C1.67973 2.9118 1.49791 2.96149 1.37285 3.08654L0.64724 3.81216C0.535662 3.92373 0.483302 4.08144 0.505987 4.23759C0.528671 4.39375 0.623738 4.53003 0.762451 4.60525L7.52306 8.27123L3.93536 11.8589L1.91215 11.5696C1.75633 11.5473 1.59911 11.5997 1.4878 11.711L0.960083 12.2387Z" stroke={color} strokeLinejoin="round" />
    </svg>

  )
}

const AirplaneSolid = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.46008 13.8485C1.34901 13.9596 1.29659 14.1164 1.31854 14.272C1.34049 14.4275 1.43426 14.5637 1.57174 14.6397L4.02652 15.9967L5.36737 18.4349C5.44316 18.5727 5.57937 18.6668 5.73507 18.689C5.89078 18.7111 6.04783 18.6587 6.15904 18.5475L6.68676 18.0198C6.79781 17.9087 6.85023 17.752 6.82831 17.5964L6.53841 15.5398L10.1105 11.9677L13.7927 18.7455C13.868 18.8841 14.0042 18.979 14.1603 19.0016C14.3164 19.0242 14.474 18.9719 14.5856 18.8603L15.3112 18.1347C15.4364 18.0095 15.486 17.8274 15.4417 17.656L13.1771 8.90106L16.8834 5.19473C17.162 4.91614 17.3071 4.56552 17.3174 4.17236L17.3175 4.17236L17.3176 4.16634C17.3233 3.76096 17.1728 3.39836 16.8828 3.10833C16.5974 2.82294 16.2386 2.6635 15.8218 2.67365C15.4267 2.68002 15.0761 2.82809 14.7964 3.10772L11.0898 6.81435L2.351 4.56574C2.17973 4.52166 1.99791 4.57135 1.87285 4.69641L1.14724 5.42202C1.03566 5.5336 0.983302 5.6913 1.00599 5.84745C1.02867 6.00361 1.12374 6.13989 1.26245 6.21511L8.02306 9.8811L4.43536 13.4688L2.41215 13.1794C2.25633 13.1571 2.09911 13.2095 1.9878 13.3208L1.46008 13.8485Z" fill={color} stroke={color} strokeLinejoin="round" />
    </svg>

  )
}

const BagOutline = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.6762 16.1205C18.6872 16.5172 18.6199 16.9123 18.4782 17.283C18.3366 17.6537 18.1232 17.9928 17.8505 18.281C17.5777 18.5692 17.2508 18.8009 16.8885 18.9627C16.5262 19.1245 16.1355 19.2133 15.7389 19.224H3.67328C2.87762 19.224 2.11451 18.908 1.5517 18.3454C0.988884 17.7829 0.672423 17.0198 0.671875 16.224L1.49928 7.91917C1.57428 7.17988 1.92167 6.49498 2.4738 5.9978C3.02593 5.50062 3.74329 5.22675 4.4862 5.22952H14.866C15.6088 5.22633 16.3261 5.50011 16.878 5.99742C17.4299 6.49473 17.7767 7.17988 17.8508 7.91917L18.6762 16.1205Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.68359 5.21515C5.68633 4.15714 6.10788 3.14328 6.85603 2.39535C7.60418 1.64742 8.61804 1.22631 9.67581 1.22412C10.2013 1.22385 10.7218 1.32715 11.2074 1.52811C11.693 1.72908 12.1342 2.02378 12.5059 2.39536C12.8776 2.76695 13.1725 3.20815 13.3737 3.69376C13.5748 4.17936 13.6784 4.69985 13.6784 5.22549" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.6784 9.52295C13.6784 10.0486 13.5748 10.5691 13.3737 11.0547C13.1725 11.5403 12.8776 11.9815 12.5059 12.3531C12.1342 12.7247 11.693 13.0194 11.2074 13.2203C10.7218 13.4213 10.2013 13.5246 9.67581 13.5243C8.61625 13.5221 7.60083 13.0996 6.85238 12.3494C6.10393 11.5993 5.68359 10.5827 5.68359 9.52295" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

const BagSolid = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.1762 16.3403C19.1872 16.737 19.1199 17.132 18.9782 17.5027C18.8366 17.8734 18.6232 18.2126 18.3505 18.5008C18.0777 18.789 17.7508 19.0206 17.3885 19.1824C17.0262 19.3442 16.6355 19.433 16.2389 19.4437H4.17328C3.37762 19.4437 2.61451 19.1277 2.0517 18.5651C1.48888 18.0026 1.17242 17.2395 1.17188 16.4437L1.99928 8.1389C2.07428 7.39961 2.42167 6.7147 2.9738 6.21752C3.52593 5.72034 4.24329 5.44648 4.9862 5.44925H15.366C16.1088 5.44606 16.8261 5.71983 17.378 6.21714C17.9299 6.71445 18.2767 7.39961 18.3508 8.1389L19.1762 16.3403Z" fill={color} stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.18359 5.43487C6.18633 4.37687 6.60788 3.36301 7.35603 2.61508C8.10418 1.86715 9.11804 1.44603 10.1758 1.44385C10.7013 1.44358 11.2218 1.54687 11.7074 1.74784C12.193 1.94881 12.6342 2.2435 13.0059 2.61509C13.3776 2.98668 13.6725 3.42788 13.8737 3.91348C14.0748 4.39909 14.1784 4.91958 14.1784 5.44522" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.1784 9.74268C14.1784 10.2683 14.0748 10.7888 13.8737 11.2744C13.6725 11.76 13.3776 12.2012 13.0059 12.5728C12.6342 12.9444 12.193 13.2391 11.7074 13.4401C11.2218 13.641 10.7013 13.7443 10.1758 13.744C9.11625 13.7419 8.10083 13.3193 7.35238 12.5691C6.60393 11.819 6.18359 10.8025 6.18359 9.74268" stroke="#E6E6E6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const LogoutIcon = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
      <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm5.03 4.72a.75.75 0 010 1.06l-1.72 1.72h10.94a.75.75 0 010 1.5H10.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0z" clipRule="evenodd" />
    </svg>
  )
}

const QrCodeAccount = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} width="40px" height="26px" viewBox="0 0 40 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Artboard</title>
      <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect id="Rectangle" fill={color} x="1" y="0" width="2" height="26"></rect>
        <rect id="Rectangle" stroke={color} fill={color} x="6.5" y="0.5" width="3" height="25"></rect>
        <rect id="Rectangle" fill={color} x="12" y="0" width="2" height="26"></rect>
        <rect id="Rectangle" fill={color} x="17" y="0" width="4" height="26"></rect>
        <rect id="Rectangle" fill={color} x="24" y="0" width="3" height="26"></rect>
        <rect id="Rectangle" fill={color} x="29" y="0" width="4" height="26"></rect>
        <rect id="Rectangle" fill={color} x="36" y="0" width="2" height="26"></rect>
      </g>
    </svg>
  )
}

const AirplaneTakeoff = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg width="35" height="25" viewBox="0 0 35 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6367_45763)">
        <path d="M33.4375 23.8403H1.5625" stroke="#14688E" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M31.0743 2.81902C31.2448 3.11449 31.357 3.43984 31.4042 3.77649C31.4515 4.11313 31.4329 4.45447 31.3496 4.78099C31.2664 5.1075 31.12 5.41279 30.9188 5.6794C30.7177 5.94601 30.4658 6.16872 30.1775 6.33479L12.9375 16.2883C12.8284 16.349 12.7039 16.3772 12.5782 16.3696L6.15539 16.364C5.98385 16.3615 5.81776 16.2957 5.68816 16.1791L2.89187 13.848C2.6384 13.6451 2.45695 13.364 2.3761 13.049C2.29524 12.7341 2.31956 12.4031 2.44523 12.1082C2.58647 11.778 2.84026 11.512 3.16118 11.3579C3.4821 11.2038 3.84919 11.1716 4.19677 11.2671L8.92714 12.6223L12.9609 10.2934L6.32841 5.07876C5.99337 4.81701 5.75889 4.44487 5.66708 4.02918C5.57527 3.61349 5.63215 3.18148 5.8275 2.81075C6.02284 2.44001 6.34386 2.15483 6.7329 2.00642C7.12194 1.85801 7.55352 1.8561 7.95012 2.00103L19.8227 6.30242L27.5748 1.82676C27.8637 1.65993 28.1836 1.55324 28.5161 1.51282C28.8486 1.4724 29.1871 1.49906 29.5123 1.59125C29.8374 1.68344 30.1428 1.83935 30.4108 2.05005C30.6789 2.26074 30.9043 2.52206 31.0743 2.81902V2.81902Z" stroke="#14688E" strokeWidth="2" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_6367_45763">
          <rect width="34" height="24.65" fill="white" transform="translate(0.5 0.239258)" />
        </clipPath>
      </defs>
    </svg>
  )
}

const AirplaneLanding = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.4375 28.8403H1.5625" stroke="#14688E" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M30.6668 19.7248C30.5785 20.0544 30.4277 20.3637 30.2231 20.6352C30.0185 20.9066 29.764 21.1349 29.4742 21.3069C29.1845 21.4789 28.8651 21.5912 28.5343 21.6375C28.2036 21.6838 27.868 21.6632 27.5467 21.5767L8.31802 16.4244C8.19788 16.3902 8.08995 16.3221 8.00647 16.2279L3.46875 11.6823C3.34927 11.5592 3.2783 11.3953 3.26914 11.2211L2.94019 7.59554C2.90445 7.27282 2.9749 6.94577 3.14044 6.66587C3.30599 6.38598 3.55723 6.16913 3.85462 6.04947C4.18797 5.91586 4.55548 5.90727 4.89137 6.02522C5.22727 6.14317 5.50962 6.37997 5.6879 6.69324L8.07447 10.9964L12.5735 12.2019L11.571 3.82475C11.5192 3.40275 11.6165 2.97381 11.8455 2.61495C12.0745 2.2561 12.4202 1.99084 12.8205 1.86682C13.2208 1.7428 13.6494 1.76815 14.0295 1.9383C14.4095 2.10845 14.716 2.41227 14.894 2.79518L20.2476 14.2319L28.8939 16.5487C29.2162 16.635 29.5179 16.7858 29.7816 16.9923C30.0452 17.1989 30.2658 17.4571 30.4305 17.7522C30.5952 18.0473 30.7009 18.3734 30.7414 18.712C30.782 19.0505 30.7566 19.3947 30.6668 19.7248V19.7248Z" stroke="#14688E" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  )
}

const NoPurchases = ({ className }: Pick<ICustomIconProps, "className">) => {
  return (
    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.756836" width="60" height="60" rx="23" fill="#E6E6E6" />
      <path d="M46.8112 47.0665L14.1914 14.4468" stroke="#14688E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M42.4657 38.5941C42.4803 39.1214 42.3909 39.6464 42.2026 40.1391C42.0143 40.6318 41.7307 41.0826 41.3682 41.4657C41.0056 41.8488 40.5711 42.1566 40.0895 42.3717C39.608 42.5867 39.0888 42.7048 38.5616 42.719H22.5245C21.4669 42.719 20.4526 42.299 19.7046 41.5513C18.9565 40.8036 18.5359 39.7893 18.5352 38.7316L19.6349 27.6932C19.7346 26.7105 20.1963 25.8002 20.9302 25.1394C21.6641 24.4785 22.6175 24.1145 23.605 24.1182H37.4013C38.3886 24.114 39.3421 24.4779 40.0757 25.1389C40.8092 25.7999 41.2702 26.7105 41.3687 27.6932L42.4657 38.5941Z" stroke="#14688E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M25.1953 24.0991C25.1989 22.6929 25.7592 21.3453 26.7537 20.3512C27.7481 19.3571 29.0956 18.7973 30.5016 18.7944C31.2001 18.7941 31.8918 18.9314 32.5373 19.1985C33.1827 19.4656 33.7692 19.8573 34.2633 20.3512C34.7573 20.8451 35.1492 21.4315 35.4166 22.077C35.684 22.7224 35.8216 23.4142 35.8216 24.1129" stroke="#14688E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M35.8216 29.8247C35.8216 30.5234 35.684 31.2152 35.4166 31.8606C35.1492 32.5061 34.7573 33.0925 34.2633 33.5864C33.7692 34.0803 33.1827 34.472 32.5373 34.7391C31.8918 35.0062 31.2001 35.1435 30.5016 35.1432C29.0933 35.1402 27.7436 34.5786 26.7488 33.5815C25.754 32.5844 25.1953 31.2333 25.1953 29.8247" stroke="#14688E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

const Calendar = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} fill={color} width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg">
      <path id="Vector" d="M8.99202 13.0096C8.72852 13.0096 8.50717 12.92 8.33326 12.7355C8.15935 12.5511 8.06976 12.335 8.06976 12.0873C8.06976 11.8238 8.15935 11.6024 8.33326 11.4285C8.50717 11.2546 8.72852 11.165 8.99202 11.165C9.25553 11.165 9.47687 11.2546 9.65078 11.4285C9.8247 11.6024 9.91429 11.8238 9.91429 12.0873C9.91429 12.335 9.8247 12.5511 9.65078 12.7355C9.47687 12.92 9.25553 13.0096 8.99202 13.0096ZM4.77595 13.0096C4.51244 13.0096 4.2911 12.92 4.11719 12.7355C3.94327 12.5511 3.85368 12.335 3.85368 12.0873C3.85368 11.8238 3.94327 11.6024 4.11719 11.4285C4.2911 11.2546 4.51244 11.165 4.77595 11.165C5.03945 11.165 5.2608 11.2546 5.43471 11.4285C5.60862 11.6024 5.69822 11.8238 5.69822 12.0873C5.69822 12.335 5.60862 12.5511 5.43471 12.7355C5.2608 12.92 5.03945 13.0096 4.77595 13.0096ZM13.2081 13.0096C12.9446 13.0096 12.7232 12.92 12.5493 12.7355C12.3754 12.5511 12.2858 12.335 12.2858 12.0873C12.2858 11.8238 12.3754 11.6024 12.5493 11.4285C12.7232 11.2546 12.9446 11.165 13.2081 11.165C13.4716 11.165 13.6929 11.2546 13.8669 11.4285C14.0408 11.6024 14.1304 11.8238 14.1304 12.0873C14.1304 12.335 14.0408 12.5511 13.8669 12.7355C13.6929 12.92 13.4716 13.0096 13.2081 13.0096ZM8.99202 17.1466C8.72852 17.1466 8.50717 17.057 8.33326 16.8673C8.15935 16.6775 8.06976 16.4667 8.06976 16.2243C8.06976 15.9608 8.15935 15.7395 8.33326 15.5656C8.50717 15.3916 8.72852 15.302 8.99202 15.302C9.25553 15.302 9.47687 15.3916 9.65078 15.5656C9.8247 15.7395 9.91429 15.9608 9.91429 16.2243C9.91429 16.472 9.8247 16.6881 9.65078 16.8673C9.47687 17.0517 9.25553 17.1466 8.99202 17.1466ZM4.77595 17.1466C4.51244 17.1466 4.2911 17.057 4.11719 16.8673C3.94327 16.6775 3.85368 16.4667 3.85368 16.2243C3.85368 15.9608 3.94327 15.7395 4.11719 15.5656C4.2911 15.3916 4.51244 15.302 4.77595 15.302C5.03945 15.302 5.2608 15.3916 5.43471 15.5656C5.60862 15.7395 5.69822 15.9608 5.69822 16.2243C5.69822 16.472 5.60862 16.6881 5.43471 16.8673C5.2608 17.0517 5.03945 17.1466 4.77595 17.1466ZM13.2081 17.1466C12.9446 17.1466 12.7232 17.057 12.5493 16.8673C12.3754 16.6775 12.2858 16.4667 12.2858 16.2243C12.2858 15.9608 12.3754 15.7395 12.5493 15.5656C12.7232 15.3916 12.9446 15.302 13.2081 15.302C13.4716 15.302 13.6929 15.3916 13.8669 15.5656C14.0408 15.7395 14.1304 15.9608 14.1304 16.2243C14.1304 16.472 14.0408 16.6881 13.8669 16.8673C13.6929 17.0517 13.4716 17.1466 13.2081 17.1466ZM1.58754 20.7566C1.18175 20.7566 0.83919 20.609 0.549335 20.3086C0.25948 20.0082 0.117188 19.6657 0.117188 19.281V4.07675C0.117188 3.67095 0.25948 3.3284 0.549335 3.03327C0.83919 2.74342 1.18702 2.60112 1.58754 2.60112H3.56383V1.389C3.56383 1.21509 3.62707 1.06226 3.74828 0.941045C3.86949 0.819833 4.02233 0.756592 4.19624 0.756592C4.39123 0.756592 4.54933 0.819833 4.67055 0.941045C4.79176 1.06226 4.855 1.21509 4.855 1.389V2.60112H13.1554V1.36265C13.1554 1.18874 13.2186 1.04118 13.3398 0.930505C13.4611 0.819833 13.6139 0.756592 13.7878 0.756592C13.9617 0.756592 14.1146 0.819833 14.2358 0.941045C14.357 1.06226 14.4202 1.20455 14.4202 1.36265V2.60112H16.3965C16.8023 2.60112 17.1449 2.74342 17.4347 3.03327C17.7246 3.32313 17.8721 3.67095 17.8721 4.07675V19.281C17.8721 19.6657 17.7246 20.0082 17.4347 20.3086C17.1449 20.609 16.797 20.7566 16.3965 20.7566H1.58754V20.7566ZM1.58754 19.5972H16.3965C16.4861 19.5972 16.5599 19.5656 16.6178 19.5076C16.6758 19.4496 16.7074 19.3706 16.7074 19.2862V8.87253H1.27134V19.281C1.27134 19.3706 1.30296 19.4443 1.3662 19.5023C1.42944 19.5603 1.50322 19.5919 1.58754 19.5919V19.5972ZM1.27134 7.71311H16.7127V4.07675C16.7127 3.98716 16.6811 3.91338 16.6231 3.85014C16.5651 3.78689 16.4861 3.75527 16.4018 3.75527H1.58754C1.49795 3.75527 1.42417 3.78689 1.36093 3.85014C1.29769 3.91338 1.26607 3.98716 1.26607 4.07675V7.71311H1.27134Z" fill="black" />
    </svg>
  )
}

const Clock = ({ className, color = 'black' }: Pick<ICustomIconProps, "className" | 'color'>) => {
  return (
    <svg className={className} fill={color} width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.5425 19.7421C15.4156 19.7421 19.366 15.7917 19.366 10.9186C19.366 6.04548 15.4156 2.09505 10.5425 2.09505C5.66938 2.09505 1.71895 6.04548 1.71895 10.9186C1.71895 15.7917 5.66938 19.7421 10.5425 19.7421ZM10.5425 20.9186C16.0653 20.9186 20.5425 16.4414 20.5425 10.9186C20.5425 5.39573 16.0653 0.918579 10.5425 0.918579C5.01963 0.918579 0.54248 5.39573 0.54248 10.9186C0.54248 16.4414 5.01963 20.9186 10.5425 20.9186Z" fill="black" />
      <path fillRule="evenodd" clipRule="evenodd" d="M10.5426 4.62292C10.8675 4.62292 11.1308 4.88629 11.1308 5.21116V10.5522H15.2833C15.6082 10.5522 15.8716 10.8156 15.8716 11.1405C15.8716 11.4653 15.6082 11.7287 15.2833 11.7287H10.5426C10.2177 11.7287 9.95435 11.4653 9.95435 11.1405V5.21116C9.95435 4.88629 10.2177 4.62292 10.5426 4.62292Z" fill="black" />
    </svg>
  )
}


export default CustomIcon;
